import { MutableRefObject, useEffect, useRef } from 'react';

import { isNewerDate } from './date-utils';

type UseLatestUpdatedAtRefArgs = {
  id: string;
  updatedAt: Date | undefined;
};

const useLatestUpdatedAtRef = ({ id, updatedAt }: UseLatestUpdatedAtRefArgs): MutableRefObject<Date | undefined> => {
  const latestUpdatedAtRef = useRef<Date | undefined>(updatedAt);
  const idRef = useRef(id);

  useEffect(() => {
    if (idRef.current !== id) {
      idRef.current = id;
      latestUpdatedAtRef.current = updatedAt;
      return;
    }
    if (isNewerDate(latestUpdatedAtRef.current, updatedAt)) {
      latestUpdatedAtRef.current = updatedAt;
    }
  }, [id, updatedAt]);

  return latestUpdatedAtRef;
};

export { useLatestUpdatedAtRef };
